import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/client'

/** Karbantartás-mód állapot (DEC-OPS-008). */
export interface MaintenanceState {
  enabled: boolean
  message: string | null
}

const MAINTENANCE_KEY = ['admin', 'maintenance'] as const

/**
 * `GET /admin/maintenance` (DEC-OPS-008) — az aktuális karbantartás-állapot.
 */
export function useMaintenance() {
  return useQuery({
    queryKey: MAINTENANCE_KEY,
    queryFn: async (): Promise<MaintenanceState> => {
      const { data, error } = await apiClient.GET('/admin/maintenance')
      if (error) throw error
      if (!data) throw new Error('Empty /admin/maintenance response')
      return { enabled: Boolean(data.enabled), message: data.message ?? null }
    },
  })
}

/**
 * `PUT /admin/maintenance` (DEC-OPS-008) — a kapcsoló + üzenet beállítása.
 */
export function useUpdateMaintenance() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: {
      enabled: boolean
      message: string | null
    }): Promise<MaintenanceState> => {
      const { data, error } = await apiClient.PUT('/admin/maintenance', { body })
      if (error) throw error
      if (!data) throw new Error('Empty /admin/maintenance response')
      return { enabled: Boolean(data.enabled), message: data.message ?? null }
    },
    onSuccess: (data) => queryClient.setQueryData(MAINTENANCE_KEY, data),
  })
}
